import React from 'react';
import { Transition as ReactTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';

interface Props {
    children: React.ReactNode;
    activeStep: number;
}

const CarouselItem = styled.div`
    position: absolute;

    &[data-state='entering'],
    &[data-state='exited'] {
        opacity: 0;
    }

    &[data-state='entered'] {
        position: relative;
        transition: opacity 400ms ease-in-out;
        opacity: 1;
    }
    &[data-state='exiting'] {
        position: relative;
        transition: opacity 400ms ease-in-out;
        opacity: 0;
    }
`;

const MultipleWinnersCarouselItem = ({ children, activeStep }: Props) => (
    <TransitionGroup>
        <ReactTransition
            key={activeStep}
            timeout={{
                // These numbers should match the transition durations
                enter: 400,
                exit: 400,
            }}
        >
            {(status: string) => <CarouselItem data-state={status}>{children}</CarouselItem>}
        </ReactTransition>
    </TransitionGroup>
);

export default MultipleWinnersCarouselItem;
